import { ReactNode } from 'react'
import { Box } from '@mui/system'
import classNames from 'classnames'
import { fieldsetGroupStyles as styles } from './FieldsetGroupStyles'

type Props = {
  children: ReactNode
  isSecondaryType?: boolean
  legend: string
  customClass?: string
  buttons?: ReactNode
}

function FieldsetGroup({
  children,
  isSecondaryType = false,
  legend,
  customClass,
  buttons
}: Props): JSX.Element {
  const fieldsGroupClassNames = classNames({
    'secondary-type': isSecondaryType,
    [`${customClass}`]: customClass
  })

  return (
    <Box sx={styles.fieldset} className={fieldsGroupClassNames}>
      <Box sx={styles.legend}>
        <Box sx={styles.legendText}>{legend}</Box>
        {buttons && <Box sx={styles.buttonsWrapper}>{buttons}</Box>}
      </Box>
      {children}
    </Box>
  )
}

export default FieldsetGroup
